import { Col, Row } from "antd";
import SelectDestination from "./SelectDestination";
import SelectCheckInOut from "./SelectCheckInOut";
import SelectRoomAndPeople from "./SelectRoomAndPeople";
import ButtonSearchHotels from "./ButtonSearchFlight";
import { FC } from "react";

type SearchingHotelsProps = {
  size?: 'default' | 'small'
  initialDates?: [string?, string?]
}

const SearchingHotels: FC<SearchingHotelsProps> = ({ size = 'default', initialDates }) => {
  const isSmall = size === 'small'
  const fieldSize = 'small' as const

  if (isSmall) {
    return (
      <div className="home__searching--hero-form home__searching--hotel-hero-form">
        <Row
          wrap={false}
          gutter={[12, 0]}
          align="bottom"
          className="home__searching--hero-row"
        >
          <Col flex="1.2 1 0" className="home__searching--hero-field-col">
            <SelectDestination size={fieldSize} indexInputFlight={0} />
          </Col>
          <Col
            flex="1.75 1 18rem"
            className="home__searching--hero-field-col home__searching--hero-dates-col"
          >
            <SelectCheckInOut size={fieldSize} initialDates={initialDates} />
          </Col>
          <Col flex="1.15 1 0" className="home__searching--hero-field-col">
            <SelectRoomAndPeople size={fieldSize} />
          </Col>
          <Col flex="none" className="home__searching--hero-search-col">
            <ButtonSearchHotels size={fieldSize} />
          </Col>
        </Row>
      </div>
    )
  }

  return (
    <Row
      wrap={false}
      gutter={[12, 0]}
      align="stretch"
      className="home__searching--hotel-search-row"
      style={{ marginBlock: '2rem' }}
    >
      <Col flex="1.15 1 14rem">
        <SelectDestination size={fieldSize} indexInputFlight={0} />
      </Col>
      <Col flex="1.65 1 18rem">
        <SelectCheckInOut size={fieldSize} initialDates={initialDates} />
      </Col>
      <Col flex="1 1 12rem">
        <SelectRoomAndPeople size={fieldSize} />
      </Col>
      <Col flex="none">
        <ButtonSearchHotels size={fieldSize} />
      </Col>
    </Row>
  );
}

export default SearchingHotels;
